module.exports = __webpack_public_path__ + "img/expiration-reminders.3a35b2fd.svg";